import { castArray, get, omit, map } from 'lodash';
import Http from '../../../http';
import * as types from './constants';
import { startLoadingList, stopLoadingList } from '../../../common/hoc/withLoaingList';

const fetchTaxes = url => (dispatch) => {
  dispatch(startLoadingList());
  const urls = castArray(url);
  return Promise.all(urls.map(singleUrl => Http.get(singleUrl)))
    .then((responses) => {
      dispatch(stopLoadingList());
      const response = responses[0];
      if (responses.length > 1) {
        responses.slice(1)
          .forEach((res) => {
            response.count += res.count;
            response.rows.push(...res.rows);
          });
      }
      dispatch({
        type: types.FETCH_TAXES,
        payload: get(response, 'rows', []),
      });

      return response;
    })
    .catch((err) => {
      dispatch(stopLoadingList());
      return err;
    });
};

const transformOutboundPayload = payload => ({
  ...omit(payload, ['shops', 'products', 'services']),
  assignments: map(payload.shops, ({ enabled = false, percentage }, ownerId) => ({
    ownerId,
    ...enabled ? {} : { deleted: true },
    ...typeof percentage === 'number' ? { percentage } : {},
  })),
});

const transformTaxablePayload = (tax, taxablesContaner) => {
  const newTaxable = [
    ...taxablesContaner.products ? Object.entries(taxablesContaner.products)
      .filter(([, enabled]) => enabled)
      .map(([id]) => ({ id, type: 'product' })) : [],
    ...taxablesContaner.services ? Object.entries(taxablesContaner.services)
      .filter(([, enabled]) => enabled)
      .map(([id]) => ({ id, type: 'service' })) : [],
  ];

  tax.taxable.forEach((existingTaxable) => {
    if (!newTaxable.find(taxable => taxable.id === existingTaxable.id)) {
      newTaxable.push({ ...existingTaxable, deleted: true });
    }
  });

  return newTaxable;
};

export const fetchShopTaxes = shopId => fetchTaxes(`/shop/${shopId}/tax`);
export const fetchBarberTaxes = (shopId, barberId) => fetchTaxes(`/shop/${shopId}/barber/${barberId}/tax`);
export const fetchBrandTaxes = brandId => fetchTaxes(`/brand/${brandId}/tax`);

const fetchTax = url => dispatch =>
  Http.get(url)
    .then(response =>
      dispatch({
        type: types.FETCH_TAX,
        payload: response,
      })
    );
export const fetchShopTax = (shopId, taxId) => fetchTax(`/shop/${shopId}/tax/${taxId}`);
export const fetchBarberTax = (shopId, barberId, taxId) => fetchTax(`/shop/${shopId}/barber/${barberId}/tax/${taxId}`);
export const fetchBrandTax = (brandId, taxId) => fetchTax(`/brand/${brandId}/tax/${taxId}`);

const addTax = (url, data) => dispatch =>
  Http.post(url, transformOutboundPayload(data))
    .then((response) => {
      dispatch({
        type: types.ADD_TAX,
        payload: response,
      });

      return response;
    });

export const addShopTax = (shopId, data) => addTax(`/shop/${shopId}/tax`, data);
export const addBarberTax = (shopId, barberId, data) => addTax(`/shop/${shopId}/barber/${barberId}/tax`, data);
export const addBrandTax = (brandId, data) => addTax(`/brand/${brandId}/tax`, data);

const updateTax = (url, data) => dispatch =>
  Http.put(url, transformOutboundPayload(data))
    .then(response =>
      dispatch({
        type: types.UPDATE_TAX,
        payload: response,
      })
    );
export const updateShopTax = (shopId, taxId, data) => updateTax(`/shop/${shopId}/tax/${taxId}`, data);
export const updateBarberTax = (shopId, barberId, taxId, data) =>
  updateTax(`/shop/${shopId}/barber/${barberId}/tax/${taxId}`, data);
export const updateBrandTax = (brandId, taxId, data) => dispatch =>
  Http.put(`/brand/${brandId}/tax/${taxId}`, transformOutboundPayload(data))
    .then(tax => Http.post(`/brand/${brandId}/apply-tax/${taxId}`, transformTaxablePayload(tax, data)))
    .then((taxApplied) => {
      dispatch({
        type: types.UPDATE_TAX,
        payload: taxApplied,
      });

      return taxApplied;
    });

const deleteTax = (url, taxId) => dispatch =>
  Http.delete(url)
    .then(() =>
      dispatch({
        type: types.DELETE_TAX,
        payload: taxId,
      })
    );
export const deleteShopTax = (shopId, taxId) => deleteTax(`/shop/${shopId}/tax/${taxId}`, taxId);
export const deleteBarberTax = (shopId, barberId, taxId) =>
  deleteTax(`/shop/${shopId}/barber/${barberId}/tax/${taxId}`, taxId);
export const deleteBrandTax = (brandId, taxId) => deleteTax(`/brand/${brandId}/tax/${taxId}`, taxId);
